import { BookingStatus } from '../types';
// Check whether there's a booked holiday "h" overlapping with incoming holiday
export const checkHolidayOverlap = (holidayBookings, startDate, endDate, startInAfternoon, endInMorning) => {
    const ststusesToSkip = [
        BookingStatus.Cancelled,
        BookingStatus.Withdrawn,
        BookingStatus.Rejected,
    ];
    return !!holidayBookings
        .filter((holiday) => !ststusesToSkip.includes(holiday.approvalStatus))
        .find((h) => compareHolidays(h, startDate, endDate, startInAfternoon, endInMorning));
};
// Compare any booked holiday "h" with incoming holiday
const compareHolidays = (h, startDate, endDate, startInAfternoon, endInMorning) => {
    const [hStart, hEnd] = [new Date(h.startDate), new Date(h.endDate)];
    // Overlap by more than one day
    if (hEnd > startDate && hStart < endDate) {
        return true;
    }
    // No overlapping at all
    if (![+hStart, +hEnd].some((n) => [+startDate, +endDate].includes(n))) {
        return false;
    }
    // Overlap by one day (start / end)
    if (+hEnd === +startDate) {
        if (!h.isEndHalfDay) {
            return !(+hStart === +hEnd &&
                h.isStartHalfDay &&
                +startDate === +endDate &&
                endInMorning);
        }
        return !startInAfternoon;
    }
    if (+hStart === +endDate) {
        if (!h.isStartHalfDay) {
            return !(+hStart === +hEnd &&
                h.isEndHalfDay &&
                +startDate === +endDate &&
                startInAfternoon);
        }
        return !endInMorning;
    }
};
